import "../assets/css/space.css";

const Space = ({ content }) => {
    return (
        <>
            <div className="space">
                <p>
                    <i className="fa-solid fa-angles-right"></i>
                    {content}
                    <i className="fa-solid fa-angles-left"></i>
                </p>
            </div>
        </>
    );
};

export default Space;
